import * as styles from './AccessDeniedPage.css';

export const ServiceUnavailablePage = () => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Service Unavailable</h1>
            <p>The service is temporarily unavailable. Please try again later.</p>
            <button onClick={() => window.location.reload()}>Retry</button>
        </div>
    );
};
